// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"27":"myapp-parent","145":"Logins","352":"my-app-helloworld","450":"About"}[chunkId] || chunkId) + "." + {"27":"0342f49a","145":"74b2a3c8","352":"712bc5fc","450":"9d11b536","924":"ae4351f3"}[chunkId] + ".js";
};